module.exports = __webpack_public_path__ + "img/grey.e39b9011.png";